import clockIcon from 'assets/icons/clockThree.svg'
import coffeeIcon from 'assets/icons/coffee.svg'
import { Modal } from 'components/Modal'
import { getWorkstreamAgendaModalData } from 'constants/WorkingModePathwaysAgendaModals'

import { ModalHeader } from './ModalHeader'

interface WorkstreamAgendaModalProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

const icons = { clock: clockIcon, coffee: coffeeIcon }

export const WorkstreamAgendaModal = ({ isOpen, onClose, id }: WorkstreamAgendaModalProps) => {
  const data = getWorkstreamAgendaModalData(id)
  if (!data) return null

  if (data.layout === 'card') {
    return (
      <Modal isOpen={isOpen} onClose={onClose} className="agenda-modal">
        <ModalHeader title={data.title} onClose={onClose} />

        <div className="agenda-modal-card-columns">
          {data.columns.map((column, index) => (
            <div key={index} className="agenda-modal-card-column">
              <div className="agenda-modal-card-column-header title-xs" style={{ background: column.headerBg }}>
                {column.headerLabel}
              </div>
              <div className="agenda-modal-card-column-body" style={{ background: column.rowsBg }}>
                {column.rows.map((row, rowIndex) => (
                  <div key={rowIndex} className="agenda-modal-card-row">
                    <span className="agenda-modal-card-row-label subtitle-xs" style={{ color: column.textcolor }}>
                      {row.label}
                    </span>
                    <span className="body-xs">{row.text}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    )
  }

  let questionColumnIndex = 0

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="agenda-modal">
      <ModalHeader title={data.title} onClose={onClose} />
      <div className="pb-6 pl-6 pr-6">
        <div className="agenda-modal-columns">
          {data.columns.map((column, index) => (
            <div key={index} className={`agenda-modal-column${column.isBreak ? ' agenda-modal-column--break' : ''}`}>
              <div
                className={`agenda-modal-column-header subtitle-xs ${column.isBreak ? ' agenda-modal-column-header--break' : ''}`}
                style={{ color: column.headerColor, background: column.headerBg }}
              >
                {column.headerLabel}
              </div>
              {column.subheaderChip && (
                <div
                  className="agenda-modal-column-chip"
                  style={{ backgroundColor: column.subheaderChip.bgColor, border: column.subheaderChip.border }}
                >
                  <img src={icons[column.subheaderChip.icon]} alt="" width={16} height={16} />
                  <span className="subtitle-l">{column.subheaderChip.label}</span>
                </div>
              )}
              {column.isBreak ? (
                <div className="agenda-modal-column-rows agenda-modal-column-rows--break">
                  <img src={coffeeIcon} alt="" width={20} height={20} />
                  <span className="body-xs">{column.rows[0].text}</span>
                </div>
              ) : (
                <ul className="agenda-modal-column-rows" style={{ background: column.rowsBg }}>
                  {column.rows.map((row, rowIndex) =>
                    row.bold ? (
                      <li key={rowIndex} className="agenda-modal-row agenda-modal-row--plain">
                        {row.label && <span className="font-bold">{row.label} </span>}
                        <span className="font-bold">{row.text}</span>
                      </li>
                    ) : (
                      <li key={rowIndex} className="agenda-modal-row agenda-modal-row--timed">
                        <span className="agenda-modal-row-label subtitle-s" style={{ color: column.textcolor }}>
                          {row.label}
                        </span>
                        <span className="body-xs">{row.text}</span>
                      </li>
                    ),
                  )}
                </ul>
              )}
            </div>
          ))}
        </div>

        {data.thoughtStarters && (
          <div className="agenda-modal-thought-starters">
            <p
              className="body-s font-bold w-full agenda-modal-thought-starters-header"
              style={{ backgroundColor: data.thoughtStarters.bgColor }}
            >
              Thought Starters: <span className="font-normal">{data.thoughtStarters.intro}</span>
            </p>
            <div className="agenda-modal-question-columns">
              {data.columns.map((column, index) => {
                if (column.isBreak) {
                  return (
                    <div key={index} className="agenda-modal-question-list agenda-modal-question-list--break">
                      <img src={coffeeIcon} alt="" width={20} height={20} />
                      <span className="body-xs">{column.rows[0].text}</span>
                    </div>
                  )
                }
                const questions = data.thoughtStarters!.questionColumns[questionColumnIndex]
                questionColumnIndex += 1
                return (
                  <ul key={index} className="agenda-modal-question-list">
                    {questions.map(question => (
                      <li key={question} className="body-xs">
                        {question}
                      </li>
                    ))}
                  </ul>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}
